import { useEffect } from "react";

import Chip from "@mui/material/Chip";

const AttendanceStatus = ({ activityDetails, student}) => {
  useEffect(() => {
  }, []);


  return (
    <>
    {activityDetails.attendanceTaken === 0 && <Chip label="ANT" variant="outlined" title="Attendance Not Taken" />}
    {activityDetails.attendanceTaken !== 0 && student.is_late === true && <Chip label="LATE" title="Late" color="primary" style={{backgroundColor: "yellow", color:"black"}} />}
    {activityDetails.attendanceTaken !== 0 && student.is_late === false && student.is_present === true && <Chip label="PRESENT" title="Present" color="primary" style={{backgroundColor: "#2e7d32", color:"white"}} />}
    {activityDetails.attendanceTaken !== 0 && student.is_late === false && student.is_present === false && <Chip label="ABSENT" title="Absent" color="secondary" />}
    </>

  );
};

export default AttendanceStatus;
